import React from 'react';
import cn from 'classnames';

import type { EmptyMapProps as Props } from './types';
import { EMPTY_BLOCK_CONTAINER_TEST_ID } from './constants';

import styles from './emptyBlock.module.css';

const EmptyBlock = ({
  className = '',
  isMobile = false,
  image,
  title,
  description,
}: Props) => (
  <div
    className={cn(className, styles.container, {
      [styles.mobileContainer]: isMobile,
    })}
    data-testid={EMPTY_BLOCK_CONTAINER_TEST_ID}
  >
    {image}
    {title && (
      <div
        className={cn(styles.title, {
          [styles.mobileTitle]: isMobile,
        })}
      >
        {title}
      </div>
    )}
    {description && <div className={styles.description}>{description}</div>}
  </div>
);

export default EmptyBlock;
